(() => {
  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(section) {
    const isEnabled = section.getAttribute('data-countdown-enabled') === 'true';
    if (!isEnabled) return;

    const elHours = section.querySelector('[data-hours]');
    const elMinutes = section.querySelector('[data-minutes]');
    const elSeconds = section.querySelector('[data-seconds]');

    // Start from 2 hours (2 * 60 * 60 * 1000 milliseconds)
    const startTime = Date.now() - (2 * 60 * 60 * 1000);

    function render() {
      const now = Date.now();
      // Calculate elapsed time since 2 hours ago (counting up)
      let diff = Math.max(0, now - startTime);

      const hours = Math.floor(diff / (60 * 60 * 1000));
      diff -= hours * 60 * 60 * 1000;
      const minutes = Math.floor(diff / (60 * 1000));
      diff -= minutes * 60 * 1000;
      const seconds = Math.floor(diff / 1000);

      if (elHours) elHours.textContent = pad2(hours);
      if (elMinutes) elMinutes.textContent = pad2(minutes);
      if (elSeconds) elSeconds.textContent = pad2(seconds);
    }

    render();
    const id = setInterval(() => {
      render();
    }, 1000);
  }

  function onReady() {
    document.querySelectorAll('.countdown-bar[data-countdown-enabled]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();


